'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserCalendarProvider } from '../../Entities/User/UserCalendarProvider';
import { UserCalendarProviderCollection } from '../../Collections/User/UserCalendarProviderCollection';

export class UserCalendarProviderRepository extends CoreRepository {
  public getUserCalendarProvider(userId: number, providerReference: string) {
    return this.webAPI.getUserCalendarProvider(userId, providerReference).then((response) => {
      const item = new UserCalendarProvider();
      item.hydrate(response);
      return item;
    });
  }

  public getUserCalendarProviders(userId: number) {
    return this.webAPI.getUserCalendarProviders(userId).then((response) => {
      const collection = new UserCalendarProviderCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserCalendarProvider();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
